import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import Home from './components/home/home';

export default function AppRouter(){
  return (
    <Router>
      <Routes>
        <Route exact path={`${process.env.PUBLIC_URL}`} element={<Home/>} />
        <Route
            path="*"
            element={<Navigate to={`${process.env.PUBLIC_URL}`} replace />}
        />
      </Routes>
    </Router>
  );
}
